import React from "react";
import { useTranslation } from "react-i18next";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "te", label: "తెలుగు" },
];

const setLanguageQueryParam = (code) => {
  const url = new URL(window.location.href);
  url.searchParams.set("ln", code);
  window.history.replaceState(null, "", `${url.pathname}${url.search}${url.hash}`);
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const handleSelect = (code) => {
    i18n.changeLanguage(code);
    setLanguageQueryParam(code);
  };

  return (
    <div className="flex items-center rounded-full border border-gray-300 text-xs font-semibold">
      {LANGUAGES.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => handleSelect(code)}
          aria-pressed={i18n.resolvedLanguage === code}
          className={`px-3 py-1 rounded-full transition-colors ${
            i18n.resolvedLanguage === code
              ? "bg-green-900 text-white"
              : "text-gray-700"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
